import FJCanvasPool from '../FJCanvasPool';
import FJExportLayer from './FJExportLayer';
import FJRenderState from './FJRenderState';
class FJVideoLayer extends FJExportLayer {
    constructor(props) {
        super(props);
        this._time = props.time;
        this._videoElement = props.videoElement;
        this._videoDecoder = props.videoDecoder;
        if (this._videoDecoder) {
            this._frameIndex = this._videoDecoder.bindFrameIndex();
        }
    }
    start() {
        this._status = FJRenderState.RENDERING;

        this._checkPrepared();
        if (this._videoDecoder && !this._videoDecoder.framePreparedAtIndex(this._frameIndex)) {
            this._videoDecoder.watchFrameAtIndex(this._frameIndex, err => {
                if (err) {
                    this._error(err);
                } else {
                    this._checkPrepared();
                }
            });
        }
    }
    _checkPrepared() {
        if (this._status === FJRenderState.RENDERING && this.prepared()) {
            this._done();
        }
    }
    /**
     * @desc 当前层是否准备好
     * @return {boolean}
     */
    prepared() {
        if (this._videoDecoder) {
            // 判断视频解码器是否报错
            if (this._videoDecoder.errMsg) {
                this._error(this._videoDecoder.errMsg);
                return false;
            }

            return this._videoDecoder.framePreparedAtIndex(this._frameIndex);
        }

        return this._mediaEnabled;
    }
    /**
     * @desc 绘制到画布
     * @param canvas
     */
    drawToCanvas(canvas) {
        try {
            if (this._videoDecoder) {
                const frame = this._videoDecoder.getFrameAtIndex(this._frameIndex);
                this._videoElement.drawVideoFrameAtTimeToCanvas(canvas, frame, this._time, {
                    transitionClock: 'timeline',
                });

                if (!this._videoDecoder.isLastFrame(frame) && frame.close) {
                    if (frame.close) {
                        frame.close();
                    } else {
                        FJCanvasPool.releaseCanvas(frame);
                    }
                }
            }
        } catch (e) {
            this._error(this._errMsg);
        }
    }
}
export default FJVideoLayer;
